import Controller from "./corporateTransportationSubmissions.controller";
import template from "./corporateTransportationSubmissions.html";

const corporateTransportationSubmissions = {
  template,
  controller: Controller,
};

export default corporateTransportationSubmissions;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmissions/corporateTransportationSubmissions.component.js